import { createInterval, DURATION_SECOND, DURATION_MINUTE, DURATION_HOUR, DURATION_DAY, DURATION_WEEK, DURATION_MONTH, DURATION_YEAR } from './time-interval';
export var utcMillisecond = createInterval(1, function (date) {
  return date;
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  date.setTime(+date + step);
}, function (date) {
  return date.getTime();
});
export var utcSecond = createInterval(DURATION_SECOND, function (date) {
  date.setUTCMilliseconds(0);
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  date.setTime(+date + DURATION_SECOND * step);
}, function (date) {
  return date.getUTCSeconds();
});
export var utcMinute = createInterval(DURATION_MINUTE, function (date) {
  date.setUTCSeconds(0, 0);
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  date.setTime(+date + DURATION_MINUTE * step);
}, function (date) {
  return date.getUTCMinutes();
});
export var utcHour = createInterval(DURATION_HOUR, function (date) {
  date.setUTCMinutes(0, 0, 0);
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  date.setTime(+date + DURATION_HOUR * step);
}, function (date) {
  return date.getUTCHours();
});
export var utcDay = createInterval(DURATION_DAY, function (date) {
  date.setUTCHours(0, 0, 0, 0);
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  date.setTime(+date + DURATION_DAY * step);
}, function (date) {
  return date.getUTCDate() - 1;
});
export var utcMonth = createInterval(DURATION_MONTH, function (date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var month = date.getUTCMonth();
  date.setUTCMonth(month + step);
}, function (date) {
  return date.getUTCMonth();
});
export var utcWeek = createInterval(DURATION_WEEK, function (date) {
  date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7) % 7);
  date.setUTCHours(0, 0, 0, 0);
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  date.setTime(+date + DURATION_WEEK * step);
}, function (date) {
  var start = utcMonth.floor(date);
  var end = new Date(+date);
  return Math.floor((+end - +start) / DURATION_WEEK);
});
export var utcYear = createInterval(DURATION_YEAR, function (date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var year = date.getUTCFullYear();
  date.setUTCFullYear(year + step);
}, function (date) {
  return date.getUTCFullYear();
});
export var utcIntervalMap = {
  millisecond: utcMillisecond,
  second: utcSecond,
  minute: utcMinute,
  hour: utcHour,
  day: utcDay,
  week: utcWeek,
  month: utcMonth,
  year: utcYear
};